
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/cra-monitoring",
      function () {
        return require("private-next-pages/docs/errors/cra-monitoring.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/cra-monitoring"])
      });
    }
  